module.exports = __webpack_public_path__ + "static/media/event-status.810770ba.png";